import { IoCheckmark } from 'react-icons/io5';
import {
  IconCardButton,
  IconCardIcon,
  IconCardInner,
  IconCardLabel,
  IconCardsGrid,
} from './shared.styles';

function IconCards({ options, value, onSelect }) {
  return (
    <IconCardsGrid>
      {options.map(option => {
        const active = value === option.label;
        const Icon = option.icon;

        return (
          <IconCardButton key={option.label} type="button" $active={active} onClick={() => onSelect(option.label)}>
            <IconCardInner>
              <IconCardIcon $active={active}>
                <Icon />
              </IconCardIcon>
              <IconCardLabel>{option.label}</IconCardLabel>
              {active &&
                < span className="check-icon">
                  <IoCheckmark size={16} strokeWidth={3} />
                </span>}
            </IconCardInner>
          </IconCardButton>
        );
      })}
    </IconCardsGrid >
  );
}

export default IconCards;
